/**
 * Dependency-free selection-level constants — the single source of truth for the default
 * level ↔ enum-key mapping.
 *
 * This module intentionally has NO imports (in particular nothing that pulls in
 * `__generated__/graphql`), so it can be imported from anywhere, including components whose
 * unit tests break on that transitive dependency. The richer,
 * `SelectionLevel`-typed helpers in `selectionLevels.ts` re-export these values with strict types.
 *
 * Default mapping: Candidate=0, Qualification=1, Interview=2, NarrowedRound=3, Hired=4.
 */

/** Leftmost default column (always first). */
export const CANDIDATE_LEVEL = 0;
/** Rightmost default column (always last). */
export const HIRED_LEVEL = 4;

/** Default enum key (string) -> integer level value. */
export const selectionLevelEnumToInt: Record<string, number> = {
  Candidate: 0,
  Qualification: 1,
  Interview: 2,
  NarrowedRound: 3,
  Hired: 4,
};

/** Integer level value -> default enum key (string). */
export const intToSelectionLevelEnum: Record<number, string> = {
  0: 'Candidate',
  1: 'Qualification',
  2: 'Interview',
  3: 'NarrowedRound',
  4: 'Hired',
};
